import * as Yup from "yup";

export default Yup.object().shape({
    uploadedFile: Yup.string().nullable(),
    name: Yup.string().required("Client's Business name is required"),
    accountNumber: Yup.string().nullable(),
    contactName: Yup.string().nullable(),
    email: Yup.string().nullable().email("Please enter a valid email"),
    additionalEmails: Yup.string().nullable(),
    primaryPhone: Yup.string().nullable(),
    address1: Yup.string().required("Address1 is required"),
    address2: Yup.string().nullable(),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    zipCode: Yup.string().required("ZipCode is required"),
    isActive: Yup.bool()
});